<template>
  <base-modal ref="modal">
    <base-card shadow>
      <div class="sm:tw-flex sm:tw-items-start">
        <div class="tw-mx-auto tw-flex-shrink-0 tw-flex tw-items-center tw-justify-center tw-h-12 tw-w-12 tw-rounded-full tw-bg-primary-100 sm:tw-mx-0 sm:tw-h-10 sm:tw-w-10">
          <comment-icon class="tw-h-6 tw-w-6 tw-text-primary-600" />
        </div>
        <div class="tw-mt-3 tw-text-center sm:tw-mt-2 sm:tw-ml-4 sm:tw-text-left tw-w-full">
          <h3 class="tw-text-xl tw-font-thin">Change Status</h3>
          <div class="tw-font-thin">{{ prescription.fullName }}: {{ prescription.businessProgramName }}</div>
          <div class="tw-mt-6 tw-w-full">
            <base-form ref="changeStatusForm">
              <base-select label="Change to" placeholder="Set Status" :options="statusOptions" label-key="displayValue" v-model="newStatus" required />
              <base-text-field label="Reason" placeholder="Enter reason" v-model="changeReason" required />
            </base-form>
          </div>
        </div>
      </div>
      <div class="sm:tw-flex sm:tw-flex-row-reverse tw-mt-4">
        <base-button @click="changeStatus" :loading="isLoading" class="tw-w-full sm:tw-w-auto sm:tw-ml-3" color="primary">Save</base-button>
        <base-button @click="hide" type="flat" class="tw-w-full sm:tw-w-auto tw-mt-2 sm:tw-mt-0" color="primary">
          Cancel
        </base-button>
      </div>
      <inline-error id="create-rx-note-modal-error" :title="errorTitle" :message="errorMessage" :error="error" />
    </base-card>
  </base-modal>
</template>

<script>
import { CommentIcon } from "@/assets/svgs";
import InlineError from "@/components/InlineError";

export default {
  name: "BusinessMemberPrescriptionChangeStatus",
  components: {
    CommentIcon,
    InlineError,
  },
  props: {
    businessId: String,
  },
  data() {
    return {
      prescription: {},
      newStatus: null,
      changeReason: null,
      isLoading: false,
      errorTitle: "",
      errorMessage: "",
      error: null,
      statusOptions: [
        { displayValue: "Contact Attempted 1", value: "contact_attempted" },
        { displayValue: "Contact Attempted 2", value: "contact_attempted_2" },
        { displayValue: "Contact Attempted 3", value: "contact_attempted_3" },
        { displayValue: "Rx Declined", value: "declined" },
        { displayValue: "Rx Accepted", value: "accepted" },
        { displayValue: "Patient Hold", value: "on_hold" },
        { displayValue: "Delayed Entry", value: "delayed_entry" },
        { displayValue: "Clarification", value: "clarify" },
        { displayValue: "No Contact", value: "no_contact" },
      ],
    };
  },
  methods: {
    reset() {
      this.prescription = {};
      this.newStatus = null;
      this.changeReason = null;
    },
    show(prescription) {
      this.prescription = prescription;
      this.statusOptions = this.statusOptions.filter((x) => x.value !== status);
      this.$refs.modal.show();
    },
    hide() {
      this.reset();
      this.$refs.modal.hide();
    },
    changeStatus() {
      if (!this.$refs.changeStatusForm.validate()) return;

      this.isLoading = true;

      this.$axios
        .put(`/businesses/${this.businessId}/prescriptions/${this.prescription.businessPrescriptionId}/status`, {
          newStatus: this.newStatus,
          changeReason: this.changeReason,
        })
        .then(() => {
          this.hide();
          this.EventBus.$emit("GLOBAL_NOTIFY", { title: "Prescription status updated", message: "The prescription status was updated successfully." });
          this.$emit("updated");
        })
        .catch((err) => {
          this.errorTitle = `Error updating staus`;
          this.errorMessage = "Sorry, we had trouble updating this status. The technicians have been notified. Please try again.";
          this.error = err;
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
  },
};
</script>
